import { experienceBuilderAiSlice } from "./slice";
import { fireVivTurn, stopVivChat } from "./thunks/fireVivTurn";
import { prepareChatMutation } from "./thunks/prepareChatMutation";
import { seedCreationHandoffOnExit } from "./thunks/seedCreationHandoffOnExit";

// `_setAutoVerifyAttempt` stays out of the public API (the continuation engine
// owns the verify-retry counter; it imports the action directly from the
// slice); everything else is public.
const { _setAutoVerifyAttempt, ...publicActions } =
  experienceBuilderAiSlice.actions;

export const ExperienceBuilderAiAction = {
  ...publicActions,
  prepareChatMutation,
  fireVivTurn,
  stopVivChat,
  seedCreationHandoffOnExit,
};

export const ExperienceBuilderAiSelector = {
  ...experienceBuilderAiSlice.selectors,
};

export { cancelContinuation, vivStreamAction } from "./actions";
// The handle setters are internal wiring (only `useVivChatBridge` registers a
// handle) — imported directly from ./vivChatWorkflowHandle, not re-exported as
// app API. The type stays public for typing the handle.
export type { VivChatWorkflowHandle } from "./vivChatWorkflowHandle";
export type { PrepareChatMutationKind } from "./thunks/prepareChatMutation";
